import { ref, } from 'vue';
import { BookingForm } from '@/classes/BookingForm.js';
class Accounting extends BookingForm {
  constructor(pms_response) {
    super(pms_response);
    
    // day_booking = [ {booking: {}, payentry: [{}], roomassign: }, ....]
    this.day_normal_booking = ref([]);
    this.day_cancel_booking = ref([]);
    
    this.stats_normal_day_booking = ref({});
    this.stats_cancel_day_booking = ref({});

    // day_payentries = [ {}, {}, .....]
    this.day_normal_payentries = ref([]);
    this.day_cancel_payentries = ref([]);
    
    this.stats_normal_payentries = ref({});
    this.stats_cancel_payentries = ref({});

    // small_ccounting = { small_entries: [{}, {}, ..], money_counting: { }}
    this.small_entries = ref([]);
    this.money_counting = ref({});

    this.stats_small_entries = ref({});

    this.current_data = ref({});
    
    this.target_date = ref("");
    
    this.account_date = ref("");
    
    this.mydate = '';

    // 2025 09 15 t_field
    this.userrole = 'user';
   
  }  
  
  // 2025 09 12 t_field
  set_userrole(role) { this.userrole = role;}
  
  get_account_date()        { return this.account_date.value; }
  set_account_date(mydate)        { this.account_date.value = mydate; }

  get_day_normal_booking()        { return this.day_normal_booking.value; }
  get_day_cancel_booking()        { return this.day_cancel_booking.value; }
  get_stats_normal_day_booking()  { return this.stats_normal_day_booking.value; }
  get_stats_cancel_day_booking()  { return this.stats_cancel_day_booking.value; }

  get_day_normal_payentries()     { return this.day_normal_payentries.value; }
  get_day_cancel_payentries()     { return this.day_cancel_payentries.value; }
  get_stats_normal_payentries()   { return this.stats_normal_payentries.value; }
  get_stats_cancel_payentries()   { return this.stats_cancel_payentries.value; }

  get_small_entries()             { return this.small_entries.value; }
  get_money_counting ()           { return this.money_counting.value; }
  
  get_stats_small_entries()       { return this.stats_small_entries.value; }

  set_current_data(payload) {
    this.current_data.value = payload;
  }  
  
  get_current_data() {
    return this.current_data.value;
  }  
  
  async add_payentry(data) {    // data={dataid, targetdate   (STRING)
    await this.update_pms('Payentries', "add", data, this.userrole);
  }
  async delete_payentry(data) {    // data=id   (STRING)
    await this.update_pms('Payentries', "delete", data, this.userrole);
  }
  
  async add_small_entry(data) {    // data={kind, what, method, income, outcome, memo, staff}
    await this.update_pms('SmallEntries', "add", data, this.userrole);
  }
  
  async update_money_counting(data) {    // data={tenthoudsnds:1, .....}
    await this.update_pms('MoneyCountings', "update", data, this.userrole);
  }
  
  async modify_checkin_status(data) { // body={dataid, newstatus:'yes'}
    await this.update_pms('Bookings', "update_checkin_status", data, this.userrole);
  }
 
  // 250907 basic_booking_info table의 t_field를 1 또는 0로 marking / unmarking하기위함
  // data = {dataid, new_t_field}
  async set_t_field(data) {
    await this.update_pms('Bookings', "set_t_field", data, this.userrole);
  }

  // 2025 09 12 t_field
  async set_t_field_small_accounting(data) {
    await this.update_pms('SmallEntries', "set_t_field_small_accounting", data, this.userrole);
  }

  
  fetch_data(mydate) {
      this.mydate = mydate;
      this.refetch();
  }
  
  async refetch() {
    await this.fetch_daybooking(this.mydate);
    await this.fetch_payentry(this.mydate);
    await this.fetch_small_entry(this.mydate);
    await this.fetch_money_counting(this.mydate);
  }

  async fetch_daybooking(data) {    // data=targetdate   (STRING)
    // 2025 09 15await this.fetch_pms('Bookings', "daybooking", data);
    await this.fetch_pms('Bookings', "daybooking", data, this.userrole);
    if (this.pms_response.type == 'success') {
      this.day_normal_booking.value = this.pms_response.response.normal;
      this.day_cancel_booking.value = this.pms_response.response.cancel;
      this.stats_normal_day_booking.value = this.get_stats_on_booking(this.day_normal_booking.value);
      this.stats_cancel_day_booking.value = this.get_stats_on_booking(this.day_cancel_booking.value);
    }
  }
  
  async fetch_payentry(data) {    // data=targetdate   (STRING)
    // 2025 09 15 t_field await this.fetch_pms('Payentries', "get", data);
    await this.fetch_pms('Payentries', "get", data, this.userrole);
    if (this.pms_response.type == 'success') {
      this.day_normal_payentries.value = this.pms_response.response.normal;
      this.day_cancel_payentries.value = this.pms_response.response.cancel;
      this.stats_normal_payentries.value = this.get_stats_on_payentries(this.day_normal_payentries.value);
      this.stats_cancel_payentries.value = this.get_stats_on_payentries(this.day_cancel_payentries.value);
    }
  }

/*  async print_daily_accounting() {
    await this.fetch_pms('PayEntries', "print_daily_accounting", this.mydate);
  }
*/
  //ok
  async fetch_small_entry(data) {    // data=targetdate   (STRING)
    // 2025 09 15 t_field await this.fetch_pms('SmallEntries', "get", data);
    await this.fetch_pms('SmallEntries', "get", data, this.userrole);
    if (this.pms_response.type == 'success') {
      this.small_entries.value = this.pms_response.response;
      this.stats_small_entries.value = this.get_stats_on_small_entries(this.small_entries.value);
    }
  }
  
  async fetch_money_counting(data) {    // data=targetdate  (STRING)
    // 2025 09 15  t_field await this.fetch_pms('MoneyCountings', "get", data);
    await this.fetch_pms('MoneyCountings', "get", data, this.userrole);
    if (this.pms_response.type == 'success') {
      this.money_counting.value = this.pms_response.response;
    }
  }
  
  get_stats_on_booking(bookings) {
    let loop_size = bookings.length;
    let loop_size_payentry = 0;
    let total_guest = Number(0);
    let total_payment = Number(0);
    let total_balance = Number(0);
    let total_price = Number(0);
    for (let i=0; i<loop_size; i++) {
      total_guest += bookings[i].booking.nguests;
      total_price += bookings[i].booking.price;
      for (let j=0; j<loop_size_payentry; j++) {
        total_payment += bookings[i].payentry[j].amount
      }
    }
    total_balance = total_price - total_payment;
    return {total_guest: total_guest, total_price: total_price, 
      total_payment: total_payment, total_balance: total_balance};
  }

  
  get_stats_on_payentries(payentries) {
    let loop_size = payentries.length;
    let total = Number(0);
    let prepay = Number(0);
    let point = Number(0);
    let cash = Number(0);
    let card = Number(0);
    let gmo = Number(0);
    let meta = Number(0);
    let bank = Number(0);
    let total2 = Number(0);
    let prepay2 = Number(0);
    let point2 = Number(0);
    let cash2 = Number(0);
    let card2 = Number(0);
    let gmo2 = Number(0);
    let meta2 = Number(0);
    let bank2 = Number(0);
    for (let i=0; i<loop_size; i++) {
      // manager1 and t_field=1이면 합산에 포함하지 않는다
      // 그러나 별도로 합계는 계산해놓는다.
      if (payentries[i].t_field==1 && this.userrole=='manager1') {
        switch(payentries[i].minor) {
          case 'prepay': prepay2 += payentries[i].amount; break;
          case 'point': point2 += payentries[i].amount; break;
          case 'cash': cash2 += payentries[i].amount; break;
          case 'card': card2 += payentries[i].amount; break;
          case 'gmo': gmo2 += payentries[i].amount; break;
          case 'meta': meta2 += payentries[i].amount; break;
          case 'bank': bank2 += payentries[i].amount; break;
        }
      }
      // 기타의 경우는 전달된 payentries에 대한 통계를 진행한다.
      else {
        switch(payentries[i].minor) {
          case 'prepay': prepay += payentries[i].amount; break;
          case 'point': point += payentries[i].amount; break;
          case 'cash': cash += payentries[i].amount; break;
          case 'card': card += payentries[i].amount; break;
          case 'gmo': gmo += payentries[i].amount; break;
          case 'meta': meta += payentries[i].amount; break;
          case 'bank': bank += payentries[i].amount; break;
        }
      }
    }

    // total2는 삭제된 예약의 합산이다.
    total2 = prepay2 + point2 + cash2 + card2 + gmo2 + meta2 + bank2;

    // total은 manager1의 경우 삭제된 예약이 제외된 합이다.
    // manager1의 경우 삭제된 것의 합산 (total2)과 삭제된 결과의 합산(total)이 모두 보여진다.
    // user는 삭제와 상관없이 모든 예약이 합산된다. 
    // manager2는 삭제된 것은 빠진 합산만 보여진다.
    total = prepay + point + cash + card + gmo + meta + bank;
    return {prepay, point, cash, card, gmo, meta, bank, total,
      prepay2, point2, cash2, card2, gmo2, meta2, bank2, total2 
     }
  }


  get_stats_on_small_entries(entries) {
    let loop_size = entries.length;
    let total = Number(0);
    let cashin = Number(0);
    let cashout = Number(0);
    let card = Number(0);
    let gmo = Number(0);
    let meta = Number(0);
    let bank = Number(0);
    let total2 = Number(0);
    let cashin2 = Number(0);
    let cashout2 = Number(0);
    let card2 = Number(0);
    let gmo2 = Number(0);
    let meta2 = Number(0);
    let bank2 = Number(0);
    for (let i=0; i<loop_size; i++) {
      // manager1 and t_field=1이면 합산에 포함하지 않는다
      // 그러나 별도로 합계는 계산해놓는다.
      if (entries[i].t_field==1 && this.userrole=='manager1') {
        switch(entries[i].method) {
          case 'cash': 
            cashin2 += entries[i].income; 
            cashout2 += entries[i].outcome;
            break;
          case 'card': card2 += entries[i].income - entries[i].outcome; break;
          case 'gmo': gmo2 += entries[i].income - entries[i].outcome; break;
          case 'meta': meta2 += entries[i].income - entries[i].outcome; break;
          case 'bank': bank2 += entries[i].income - entries[i].outcome; break;
        }
      }
      // 기타의 경우는 전달된 payentries에 대한 통계를 진행한다.
      else {
        switch(entries[i].method) {
          case 'cash': 
            cashin += entries[i].income; 
            cashout +=entries[i].outcome; 
            break;
          case 'card': card += entries[i].income - entries[i].outcome; break;
          case 'gmo': gmo += entries[i].income - entries[i].outcome; break;
          case 'meta': meta += entries[i].income - entries[i].outcome; break;
          case 'bank': bank += entries[i].income - entries[i].outcome; break;
        }
      }
    }

    // total2는 삭제된 예약의 합산이다.
    total2 = cashin2 - cashout2 + card2 + gmo2 + meta2 + bank2;

    // total은 manager1의 경우 삭제된 예약이 제외된 합이다.
    // manager1의 경우 삭제된 것의 합산 (total2)과 삭제된 결과의 합산(total)이 모두 보여진다.
    // user는 삭제와 상관없이 모든 예약이 합산된다. 
    // manager2는 삭제된 것은 빠진 합산만 보여진다.
    total = cashin - cashout + card + gmo + meta + bank;
    return {cashin, cashout, card, gmo, meta, bank, total,
            cashin2, cashout2, card2, gmo2, meta2, bank2, total2 }
  }

  getO_A_N(agent, outdate, nights) {
    return outdate.substr(6, 2) + "-" + agent + " (" + nights + ")";
  }

  mypaystatus(price, payentry) {
    var mybalance;
    mybalance = price - this.sumOfPaymentIncludingLoss(payentry);
    if (mybalance == 0) return 'yes';
    else if (mybalance > 0) return 'no';
    else return 'over';
  }

  sumOfPaymentIncludingLoss(mypayentries) {
    var mytotal = Number(0);
    mypayentries.forEach((value) => {
      mytotal += Number(value.amount);
    });
    return mytotal;
  }

  isprepaid(myway, payentry) {
    var loopsize = payentry.length;
    if (myway == 'Yes') return 'pyes';
    else {
      for (var i = 0; i < loopsize; i++) {
        if (payentry[i].minor == 'prepay') return 'pyes';
      }
    }
    return 'pno';
  }

  add_2_price(prepay, nonrefundable, breakfast, prepayable) {
    var mybreak = breakfast;
    if (breakfast == '朝食' || breakfast == '朝食2') mybreak = '朝食';
    // adding 14 days in advance prepayable
    if ((prepay != 'pyes') && (nonrefundable != 'Yes') && (mybreak != '朝食') && (prepayable != 'FOURTEEN') && (prepayable != 'THREE')) return "";
    var build = "";
    if (prepay == 'pyes') build += "💰";
    if (mybreak == '朝食') build += "🍴";
    if (nonrefundable == 'Yes') { build += "👎"; return build; }      //   �🚫😍💰🅿🙅🈚🈲👎❌🔟 
    if (prepayable == 'SEVEN') build += "7️⃣";
    if (prepayable == 'FOURTEEN') build += "🔟";
    if (prepayable == 'THREE') build += "3️⃣";
    return build;
  }

  sumOfPayments(payentry) {
    let total = Number(0);
    payentry.forEach(function (value) {
      total = total + Number(value.amount);
    })

    return total;
  }
}
export let accounting = new Accounting();
